export default {
  Id: '',
  Name: '',

};
